
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { openCookiePreferences } from "@/utils/cookieConsent";
import { RiptydeLink } from "@/components/RiptydeLink";

const Footer = () => {
  return (
    <footer className="bg-background border-t mb-10 lg:mb-0">
      <div className="container px-4 md:px-6 py-8 md:py-12">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="mb-8 md:mb-0">
            <div className="flex items-center gap-2 mb-4">
              <Link to="/" className="flex items-center gap-2">
                <img src="/img/demostoke-logo-ds-transparent-cropped.webp" alt="DemoStoke logo" className="w-6 h-6" />
                <span className="text-lg font-bold" style={{ fontFamily: 'Tahoma, sans-serif', color: 'hsl(186 100% 48%)' }}>DemoStoke</span>
              </Link>
            </div>
            <p className="text-sm text-muted-foreground max-w-xs mb-4">
              Find it. Ride it. Love it? Buy it.
            </p>
            <Button asChild>
              <Link to="/contact-us">Contact Us</Link>
            </Button>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div className="space-y-3">
              <h4 className="text-sm font-medium">Product</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/explore" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Find Equipment
                  </Link>
                </li>
                {/* <li>
                  <Link to="list-your-gear" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    List Your Gear
                  </Link>
                </li> */}
                <li>
                  <Link to="/how-it-works" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    How It Works
                  </Link>
                </li>
                <li>
                  <RiptydeLink
                    source="footer"
                    iconSize={16}
                    iconClassName="h-4 w-4 rounded"
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    Riptyde Surf Forecast
                  </RiptydeLink>
                </li>
              </ul>
            </div>

            <div className="space-y-3">
              <h4 className="text-sm font-medium">Company</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Blog
                  </Link>
                </li>
                {/* <li>
                  <Link to="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Partners
                  </Link>
                </li> */}
              </ul>
            </div>

            <div className="space-y-3">
              <h4 className="text-sm font-medium">Legal</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/privacy-policy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms-of-service" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={openCookiePreferences}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    Cookie Settings
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={openCookiePreferences}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors text-left"
                  >
                    Do Not Sell or Share My Information
                  </button>
                </li>
                {/* <li>
                  <Link to="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    FAQ
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} DemoStoke. All rights reserved.
          </p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <Link to="#" className="text-muted-foreground hover:text-foreground transition-colors">
              <span className="sr-only">Twitter</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-twitter">
                <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
              </svg>
            </Link>
            <Link to="#" className="text-muted-foreground hover:text-foreground transition-colors">
              <span className="sr-only">Instagram</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-instagram">
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
              </svg>
            </Link>
            <Link to="#" className="text-muted-foreground hover:text-foreground transition-colors">
              <span className="sr-only">Facebook</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-facebook">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
